import { ref } from '@vue/composition-api'
import { DataCreator, RowsData, ColumnsData } from './core.js'
class RefDataCreator extends DataCreator {
    constructor(){
        super();
    }
    /** 
     * 建立 Rows 資料 
     * @override
     * @returns {RowsData}
     */
    createRowsData(){
        return new RefRowsData()
    }
    /** 
     * 建立 Columns 資料 
     * @override
     * @returns {ColumnsData}
     */
    createColumnsData(){
        return new RefColumnsData()
    }
}
class RefRowsData extends RowsData {
    constructor(){
        super();
        /** @type {Object} */
        this.data = ref([]);
    }
    /**
     * @override
     * @returns {Array}
     */
    getData(){
        return this.data?.value;
    }
    /**
     * @override
     * @param {Array}
     */
    setData(array){
        this.data = ref(array);
    }
}
class RefColumnsData extends ColumnsData {
    constructor(){
        super();
        /** @type {Object} */
        this.data = ref([]);
    }
    /**
     * @override
     * @returns {Array}
     */
    getData(){
        return this.data?.value;
    }
    /**
     * @override
     * @param {Array}
     */
    setData(array){
        
        this.data = ref(array);
    }
}

export default {
    RefDataCreator
}